import React from 'react';
import './step-progress-bar.css';
var StepStatus;
(function (StepStatus) {
    StepStatus["ADMINISTERED"] = "ADMINISTERED";
    StepStatus["INTERRUPTED"] = "INTERRUPTED";
    StepStatus["PENDING"] = "PENDING";
    StepStatus["STARTED"] = "STARTED";
    StepStatus["DELAYED"] = "DELAYED";
    StepStatus["SUSPENDED"] = "SUSPENDED";
})(StepStatus || (StepStatus = {}));
function StepProgressBar({ allStepStatus, leftText }) {
    const getStepClass = (status) => {
        switch (status) {
            case StepStatus.ADMINISTERED:
                return '--completed';
            case StepStatus.INTERRUPTED:
            case StepStatus.STARTED:
                return '--started';
            case StepStatus.PENDING:
                return '';
            case StepStatus.DELAYED:
                return '--delayed';
            case StepStatus.SUSPENDED:
                return '--suspended';
            default:
                return '';
        }
    };
    return (React.createElement("div", { className: 'c-step-progress-bar' },
        React.createElement("div", { className: 'c-step-progress-bar__counter' }, leftText),
        React.createElement("div", { className: 'c-step-progress-bar__steps' }, allStepStatus.map((status, index) => {
            const stepCount = index + 1;
            return (React.createElement("div", { key: stepCount, className: `c-step-progress-bar__step ${getStepClass(status)}` }));
        }))));
}
export { StepProgressBar, };
//# sourceMappingURL=step-progress-bar.js.map